<template>
  <div>
    <!-- <div
      class="h-10rem w-full flex align-items-center justify-content-center"
      style="background-color: rgb(15, 76, 56)"
    > -->
    <div
      class="h-20rem w-full flex align-items-center justify-content-center bg-cover bg-center bg-no-repeat"
      style="background-image: url('/images/home_img1.webp')"
    >
      <!-- <div class="text-white text-5xl font-medium">{{ title }}</div> -->
      <div class="text-primary text-5xl font-medium">{{ title }}</div>
      <br />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps(['title', 'description'])
const title = ref(props.title || 'Test Title')
</script>
<style lang="scss"></style>
